export const STATUS_COLORS = {
  Confermato: {
    background: "#E3F7E2",
    text: "#5EB45A",
  },
  "In attesa": {
    background: "#FFF9D6",
    text: "#DC854A",
  },
  Bloccato: {
    background: "#FEE9E9",
    text: "#DA2F2F",
  },
  Default: {
    background: "#757575",
    text: "#757575",
  },
};

export const STATUS_TRANSLATIONS = {
  Confirmed: "Confermato",
  "On Pending": "In attesa",
  Blocked: "Bloccato",
};

export const TYPE_COLORS = {
  Sabbioso: {
    background: "#DC854A",
  },
  Roccioso: { background: "#4A6CDC" },
  Limoso: { background: "#5EB45A" },
  Torboso: { background: "#4AA4DC" },
  Ghiaioso: { background: "#5AA4DC" },
  Granitico: { background: "#8B7D6B" },
  Scistoso: { background: "#6B5B95" },
  Calcareo: { background: "#E8D5B7" },
  Default: { background: "#757575" },
};

export const SENSOR_STATUS_COLORS = {
  Connesso: {
    background: "#E3F7E2",
    text: "#5EB45A",
  },
  Disconnesso: {
    background: "#FEE9E9",
    text: "#DA2F2F",
  },
  Sconosciuto: {
    background: "#EEF0F2",
    text: "#757575",
  },
  Default: {
    background: "#EEF0F2",
    text: "#757575",
  },
};
